import { atom } from 'recoil';
import { getFromLS } from '../../lib/util/useLocalStorage';

const langAtom = atom<'indonesian' | 'english'>({
  key: 'appLangAtomKey',
  default: getFromLS('lang') === 'indonesian' ? 'indonesian' : 'english',
});

export default langAtom;
